import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Title from "../../components/Title";
import Button from "../../components/Button";
import { API_ERROR_500 } from "../../../../config";

const ValidatePan = () => {
  const history = useHistory();
  const preRef = useRef(null);
  const [panInfo, setPanInfo] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const initialValues = {
    pan: "",
    dob: "",
  };

  const validationSchema = Yup.object().shape({
    pan: Yup.string()
      .min(10)
      .required("PAN number is required.")
      .matches("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$", "Invalid PAN number"),
  });

  const getApiUrl = () => {
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    let API_URL = "";
    if (portal_domain) {
      API_URL = portal_domain.substring(0, portal_domain.length - 1);
    }
    return API_URL;
  };

  const getApiHeader = () => {
    const token = window.sessionStorage.getItem("token");
    let headers = "";
    if (token) {
      headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
    }
    return headers;
  };

  useEffect(() => {
    const header = getApiHeader();
    if (!header) {
      return history.push("/");
    }
    return () => {};
  }, [history]);

  const handleReset = (resetForm) => {
    setPanInfo(null);
    resetForm();
  };

  const handleSubmit = async (value) => {
    const payload = {
      ...value,
      dob: "01-01-1990",
    };
    setLoading(true);
    const url = getApiUrl();
    const header = getApiHeader();
    try {
      const resp = await axios.post(
        `${url}/api/method/kyc_customizations.apis.kyc_verification.api.verify_pan`,
        payload,
        header
      );
      console.log("resp", resp);
      setPanInfo(resp.data);
      setLoading(false);
    } catch (error) {
      const { response } = error || {};
      console.log("error", response);
      setPanInfo(response.data);
      setLoading(false);
      toast.error(response?.data?.message || API_ERROR_500);
    }
  };

  const copyJson = () => {
    if (preRef.current) {
      const jsonData = preRef.current.innerText;
      navigator.clipboard
        .writeText(jsonData)
        .then(() => {
          alert("JSON data copied to clipboard!");
        })
        .catch((error) => {
          console.error("Failed to copy JSON data:", error);
        });
    }
  };

  return (
    <div>
      <div className="container col-md-6">
        <Title title="PAN Details" />
        <div className="ml-2">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue, resetForm }) => (
              <Form>
                <div className="form-group my-2">
                  <label className="py-1">PAN Number</label>
                  <Field
                    type="text"
                    name="pan"
                    placeholder="Pan Number"
                    className="form-control"
                    onChange={({ target }) =>
                      setFieldValue("pan", target.value.toUpperCase())
                    }
                    maxLength="10"
                  />
                  <ErrorMessage
                    name="pan"
                    className="inline-errormsg my-1"
                    component="div"
                  />
                </div>
                <div className="d-flex form-group my-4">
                  <div className="mx-2">
                    <Button
                      type="reset"
                      title="Clear"
                      handleClick={() => handleReset(resetForm)}
                      disabled={isLoading}
                    />
                  </div>
                  <div className="mx-2">
                    <Button
                      type="submit"
                      title={isLoading ? "Loading..." : "Submit"}
                      disabled={isLoading}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>

          {panInfo && (
            <div class="row m-2">
              <div class="col-sm-12">
                <pre ref={preRef}>{JSON.stringify(panInfo, null, 4)}</pre>
                <button className="btn btn-primary" onClick={copyJson}>
                  Copy
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ValidatePan;
